<div class="profile-container">
    <div class="profile-content">
        <div class="personal-details">
            <div class="header-block">
                <div class="header-title">
                    <p style="margin: 0; font-size: 1.25rem; font-weight: 600;">Episodes Workflow</p>
                </div>
                <div class="add-block">
                    <button *ngIf="actionControls.isAdd" title="Add" data-toggle="modal" data-target="#exampleModal">
                        <i class="bi bi-plus-lg"></i> Add
                    </button>
                    <div class="filter-icon">
                        <!-- <i class="bi bi-funnel" title="Filter" routerLink="/tv-production-tracker-filter"></i> -->
                        <i class="bi bi-arrow-clockwise" title="Refresh" (click)="refreshAll()"></i>
                    </div>
                </div>
            </div>

            <div class="desktop-view">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="width: 15%;">Id</th>
                            <th style="width: 15%;">Episode Name</th>
                            <th style="width: 15%;">Anchor</th>
                            <th style="width: 15%;">Director</th>
                            <th style="width: 15%;">Shoot Date</th>
                            <th style="width: 15%;">Status</th>
                            <th style="width: 10%;text-align: center;padding: 0;">Action</th>
                        </tr>
                    </thead>
                </table>

                <div *ngIf="!isLoading">
                    <div class="data-view" id="{{episode.id}}"
                        [ngClass]="{ 'delete-highlight': episode.id == recordId }" *ngFor="let episode of episodeList | paginate : {
                        itemsPerPage: tableSize,
                        currentPage: pageNumber,
                        totalItems: totalRecords
                        }">
                        <p style="width: 15%;">{{episode.tvProductionTrackerId || " -- " }}</p>

                        <p style="width: 15%;" [title]="episode.episodeName">{{episode.episodeName || " -- " }}</p>
                        <p style="width: 15%;">{{episode.anchorUser || " -- " }}</p>
                        <p style="width: 15%;">{{episode.director || " -- " }}</p>
                        <p style="width: 15%;">{{ (episode.shootDate && episode.shootDate !== 0 ? (episode.shootDate |
                            date:'mediumDate') : null) || " -- " }}</p>
                        <p style="width: 15%;">{{statusMap[episode.episodeStatus] || episode.episodeStatus || " -- " }}
                        </p>

                        <p class="action-buttons" style="width: 10%;padding-left: 25px;">
                            <i data-toggle="modal" title="View" (click)="viewEpisodeById(episode.tvProductionTrackerId)"
                                data-target="#viewModal" class="bi bi-eye-fill"></i>
                            <i *ngIf="actionControls.isModify" title="Edit" class="bi bi-pencil-square"
                                (click)="getEpisodeById(episode.tvProductionTrackerId)" data-toggle="modal"
                                data-target="#editModal"></i>
                            <i *ngIf="actionControls.isDelete" title="Delete" class="bi bi-trash3"
                                (click)="deleteIdSelect(episode.id, episode)" data-toggle="modal"
                                data-target="#deleteModal"></i>
                        </p>
                    </div>
                </div>
            </div>

            <!-- Mobile Card View -->
            <div class="mobile-view" *ngIf="!isLoading">
                <div class="episode-card" [ngClass]="{ 'delete-highlight': episode.id == recordId }" *ngFor="let episode of episodeList | paginate : {
                    itemsPerPage: tableSize,
                    currentPage: pageNumber,
                    totalItems: totalRecords
                    }">
                    <div class="card-header">
                        <h3>{{episode.episodeName || "Unnamed Episode" }}</h3>
                        <div class="actions">
                            <i data-toggle="modal" title="View" (click)="viewEpisodeById(episode.tvProductionTrackerId)"
                                data-target="#viewModal" class="bi bi-eye-fill"></i>
                            <i *ngIf="actionControls.isModify" title="Edit" class="bi bi-pencil-square"
                                (click)="getEpisodeById(episode.tvProductionTrackerId)" data-toggle="modal"
                                data-target="#editModal"></i>
                            <i *ngIf="actionControls.isDelete" title="Delete" class="bi bi-trash3"
                                (click)="deleteIdSelect(episode.id, episode)" data-toggle="modal"
                                data-target="#deleteModal"></i>
                        </div>
                    </div>

                    <div class="status"
                        [ngClass]="{'pending': episode.episodeStatus?.includes('PENDING'), 'inprogress': episode.episodeStatus === 'EPISODE_CREATION' || episode.episodeStatus === 'QC_REJECTED'}">
                        <i class="bi bi-check-circle-fill" *ngIf="episode.episodeStatus?.includes('COMPLETED')"></i>
                        {{statusMap[episode.episodeStatus] || episode.episodeStatus || "PENDING" }}
                    </div>

                    <div class="details">
                        <div class="detail-row">
                            <span>Id</span>
                            <strong>{{episode.tvProductionTrackerId || "--"}}</strong>
                        </div>
                        <div class="detail-row">
                            <span>Anchor</span>
                            <strong>{{episode.anchorUser || "--"}}</strong>
                        </div>
                        <div class="detail-row">
                            <span>Director</span>
                            <strong>{{episode.director || "--"}}</strong>
                        </div>
                        <div class="detail-row">
                            <span>Shoot Date</span>
                            <strong>{{ (episode.shootDate && episode.shootDate !== 0 ? (episode.shootDate |
                                date:'mediumDate') : null) || "--" }}</strong>
                        </div>
                    </div>
                </div>
            </div>

            <div class="loader" *ngIf="isLoading">
                <div class="spinner"></div>
            </div>

            <div class="loader" *ngIf="!isLoading && episodeList.length == 0">
                <div class="no-data">
                    <img src="assets/no-data-6.png" alt="">
                    <p>no data found</p>
                </div>
            </div>

            <div class="paginator">
                <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize"
                    [totalRecords]="totalRecords" [showFirstLastIcon]="false" [showCurrentPageReport]="true"
                    currentPageReportTemplate="{first} - {last} of {totalRecords}"></p-paginator>
            </div>
        </div>
    </div>
</div>

<!-- Add Modal -->
<div class="modal fade" id="exampleModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Add Episode
                    <span data-dismiss="modal">
                        <i class="bi bi-x-lg" (click)="closePopUp()" id="closeModalButton1"></i>
                    </span>
                </h5>
            </div>
            <div class="modal-body">
                <div [formGroup]="episodeForm">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Episode Name <span class="required">*</span></label>
                                <input formControlName="episodeName" type="text" class="form-control">

                                <span class="err" *ngIf="episodeForm.get('episodeName').invalid && formSubmit">Episode
                                    Name required</span>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Episode Type <span class="required">*</span></label>
                                <select formControlName="episodeType" class="form-control">
                                    <option value="">Select Episode Type</option>
                                    <option *ngFor="let type of episodeTypes" [value]="type">{{type}}</option>
                                </select>
                                <span class="err" *ngIf="episodeForm.get('episodeType').invalid && formSubmit">Episode
                                    Type required</span>
                            </div>
                        </div>
                        <!-- <div class="col-md-12">
                            <div class="form-group">
                                <label>YouTube URL</label>
                                <input formControlName="episodeYouTubeURL" type="text" class="form-control">
                            </div>
                        </div> -->
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Anchor <span class="required">*</span></label>
                                <select formControlName="anchorUser" class="form-control">
                                    <option value="">Select Anchor</option>
                                    <option *ngFor="let user of anchorUserList" [value]="user.userName">
                                        {{user.userName}}</option>
                                </select>
                                <span class="err"
                                    *ngIf="episodeForm.get('anchorUser').invalid && (formSubmit || episodeForm.get('anchorUser').touched)">Anchor
                                    required</span>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Director <span class="required">*</span></label>
                                <select formControlName="director" class="form-control">
                                    <option value="">Select Director</option>
                                    <option *ngFor="let user of directorUserList" [value]="user.userName">
                                        {{user.userName}}</option>
                                </select>
                                <span class="err"
                                    *ngIf="episodeForm.get('director').invalid && (formSubmit || episodeForm.get('director').touched)">Director
                                    required</span>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Guest</label>
                                <input formControlName="guest1" type="text" class="form-control">
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Shoot Date <span class="required">*</span></label>
                                <input formControlName="shootDate" type="date" class="form-control">
                                <span class="err" *ngIf="episodeForm.get('shootDate').invalid && formSubmit">Shoot Date
                                    required</span>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Shoot Time <span class="required">*</span></label>
                                <input formControlName="shootTime" type="time" class="form-control">
                                <span class="err"
                                    *ngIf="episodeForm.get('shootTime').invalid && (formSubmit || episodeForm.get('shootTime').touched)">Shoot
                                    Time required</span>
                            </div>
                        </div>

                        <div class="col-md-12 mt-3 mb-3">
                            <div class="toggle-switch-wrapper">
                                <label class="toggle-switch">
                                    <input type="checkbox" formControlName="outDoor" id="outDoorCheck">
                                    <span class="toggle-slider"></span>
                                </label>
                                <label for="outDoorCheck" style="font-weight: 600; font-size: 0.95rem;">Outdoor Shoot</label>
                            </div>
                        </div>

                        <!-- Cameraman and PCR fields removed from Add Modal -->
                    </div>
                </div>
                <div class="modal-footer" style="padding: 1.75rem 0 0 0; border-top: none;">
                    <button type="button" class="btn btn-secondary" (click)="closePopUp()"
                        data-dismiss="modal">Close</button>
                    <button type="button" class="btn btn-primary" (click)="addEpisode()">Add Episode</button>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Edit Modal -->
<div class="modal fade" id="editModal" tabindex="-1" data-backdrop="static" aria-labelledby="editModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="editModalLabel">Edit Episode
                    <span data-dismiss="modal">
                        <i class="bi bi-x-lg" (click)="closePopUp()" id="closeModalButton2"></i>
                    </span>
                </h5>
            </div>
            <div class="modal-body">
                <div [formGroup]="episodeUpdateForm">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Episode Name <span class="required">*</span></label>
                                <input formControlName="episodeName" type="text" class="form-control">
                                <span class="err"
                                    *ngIf="episodeUpdateForm.get('episodeName').invalid && formSubmit">Episode Name
                                    required</span>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Episode Type <span class="required">*</span></label>
                                <select formControlName="episodeType" class="form-control">
                                    <option value="">Select Episode Type</option>
                                    <option *ngFor="let type of episodeTypes" [value]="type">{{type}}</option>
                                </select>
                                <span class="err"
                                    *ngIf="episodeUpdateForm.get('episodeType').invalid && formSubmit">Episode Type
                                    required</span>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>YouTube URL</label>
                                <input formControlName="episodeYouTubeURL" type="text" class="form-control">
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Anchor <span class="required">*</span></label>
                                <select formControlName="anchorUser" class="form-control">
                                    <option value="">Select Anchor</option>
                                    <option *ngFor="let user of anchorUserList" [value]="user.userName">
                                        {{user.userName}}</option>
                                </select>
                                <span class="err"
                                    *ngIf="episodeUpdateForm.get('anchorUser').invalid && (formSubmit || episodeUpdateForm.get('anchorUser').touched)">Anchor
                                    required</span>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Director <span class="required">*</span></label>
                                <select formControlName="director" class="form-control">
                                    <option value="">Select Director</option>
                                    <option *ngFor="let user of directorUserList" [value]="user.userName">
                                        {{user.userName}}</option>
                                </select>
                                <span class="err"
                                    *ngIf="episodeUpdateForm.get('director').invalid && (formSubmit || episodeUpdateForm.get('director').touched)">Director
                                    required</span>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Guest 1</label>
                                <input formControlName="guest1" type="text" class="form-control">
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Guest 2</label>
                                <input formControlName="guest2" type="text" class="form-control">
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Shoot Date <span class="required">*</span></label>
                                <input formControlName="shootDate" type="date" class="form-control">
                                <span class="err"
                                    *ngIf="episodeUpdateForm.get('shootDate').invalid && (formSubmit || episodeUpdateForm.get('shootDate').touched)">Shoot
                                    Date required</span>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Shoot Time <span class="required">*</span></label>
                                <input formControlName="shootTime" type="time" class="form-control">
                                <span class="err"
                                    *ngIf="episodeUpdateForm.get('shootTime').invalid && (formSubmit || episodeUpdateForm.get('shootTime').touched)">Shoot
                                    Time required</span>
                            </div>
                        </div>
                        
                        <div class="col-md-12 mt-3 mb-3">
                            <div class="toggle-switch-wrapper">
                                <label class="toggle-switch">
                                    <input type="checkbox" formControlName="outDoor" id="outDoorCheckEdit">
                                    <span class="toggle-slider"></span>
                                </label>
                                <label for="outDoorCheckEdit" style="font-weight: 600; font-size: 0.95rem;">Outdoor Shoot</label>
                            </div>
                        </div>

                        <!-- Cameraman and PCR fields removed from Edit Modal -->
                    </div>
                </div>
                <div class="modal-footer" style="padding: 1.75rem 0 0 0; border-top: none;">
                    <button type="button" class="btn btn-secondary" (click)="closePopUp()"
                        data-dismiss="modal">Close</button>
                    <button type="button" class="btn btn-primary" (click)="updateEpisode()">Update</button>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- View Modal -->
<div class="modal fade" id="viewModal" tabindex="-1" data-backdrop="static" aria-labelledby="viewModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg" style="max-width: 1400px;">
        <div class="modal-content ent-modal-content">

            <div class="modal-header ent-modal-header">
                <div class="ent-header-left">
                    <h5 class="modal-title ent-title" id="viewModalLabel">Episode Details</h5>
                    <p class="ent-subtitle">TV Production Workflow</p>
                </div>
                <div class="ent-header-right">
                    <span class="ent-badge" [ngClass]="{
                        'ent-badge-success': singleEpisodeData[0]?.episodeStatus?.includes('COMPLETED'),
                        'ent-badge-warning': singleEpisodeData[0]?.episodeStatus?.includes('PENDING') || singleEpisodeData[0]?.episodeStatus === 'EPISODE_CREATION',
                        'ent-badge-primary': !singleEpisodeData[0]?.episodeStatus?.includes('COMPLETED') && !singleEpisodeData[0]?.episodeStatus?.includes('PENDING')
                    }">
                        {{statusMap[singleEpisodeData[0]?.episodeStatus] || singleEpisodeData[0]?.episodeStatus ||
                        'PENDING'}}
                    </span>
                    <button type="button" class="close ent-close-btn" data-dismiss="modal" aria-label="Close"
                        (click)="closePopUp()" id="closeViewModalButton">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            </div>

            <div class="modal-body ent-modal-body" *ngIf="singleEpisodeData[0]">

                <!-- Workflow Stepper -->
                <div class="ent-stepper-container">
                    <ng-container *ngFor="let step of workflowSteps; let last = last">
                        <div class="ent-step"
                            [ngClass]="{'completed': isStageCompleted(singleEpisodeData[0]?.currentStage, step.stage), 'active': isStageActive(singleEpisodeData[0]?.currentStage, step.stage)}">
                            <div class="ent-step-circle"></div>
                            <div class="ent-step-label">{{step.label}}</div>
                        </div>
                        <div *ngIf="!last" class="ent-step-connector"
                            [ngClass]="{'completed': isStageCompleted(singleEpisodeData[0]?.currentStage, step.stage)}">
                        </div>
                    </ng-container>
                </div>

                <div class="ent-grid">

                    <!-- Episode Information Card -->
                    <div class="ent-card">
                        <h5 class="ent-card-title">Episode Information</h5>
                        <div class="ent-card-grid-3">

                            <div class="ent-field"><span class="ent-label">Id</span><span
                                    class="ent-value">{{singleEpisodeData[0].tvProductionTrackerId || '--'}}</span>
                            </div>
                            <div class="ent-field"><span class="ent-label">Episode Name</span><span
                                    class="ent-value">{{singleEpisodeData[0].episodeName || '--'}}</span></div>
                            <div class="ent-field"><span class="ent-label">Episode Type</span><span
                                    class="ent-value">{{singleEpisodeData[0].episodeType || '--'}}</span></div>
                            <div class="ent-field"><span class="ent-label">Anchor</span><span
                                    class="ent-value">{{singleEpisodeData[0].anchorUser || '--'}}</span></div>
                            <div class="ent-field"><span class="ent-label">Director</span><span
                                    class="ent-value">{{singleEpisodeData[0].director || '--'}}</span></div>
                            <div class="ent-field">
                                <span class="ent-label">Guest</span>
                                <span class="ent-value">
                                    <ng-container
                                        *ngIf="singleEpisodeData[0].guest1">{{singleEpisodeData[0].guest1}}</ng-container>
                                    <ng-container *ngIf="singleEpisodeData[0].guest1 && singleEpisodeData[0].guest2">,
                                    </ng-container>
                                    <ng-container
                                        *ngIf="singleEpisodeData[0].guest2">{{singleEpisodeData[0].guest2}}</ng-container>
                                    <ng-container
                                        *ngIf="!singleEpisodeData[0].guest1 && !singleEpisodeData[0].guest2">--</ng-container>
                                </span>
                            </div>
                            <div class="ent-field"><span class="ent-label">Status Badge</span><span
                                    class="ent-value">{{statusMap[singleEpisodeData[0]?.episodeStatus] ||
                                    singleEpisodeData[0].episodeStatus || '--'}}</span></div>
                            <div class="ent-field"><span class="ent-label">Shoot Date</span><span class="ent-value">{{
                                    (singleEpisodeData[0].shootDate && singleEpisodeData[0].shootDate !== 0 ?
                                    (singleEpisodeData[0].shootDate | date:'mediumDate') : null) || '--'}}</span></div>
                            <div class="ent-field"><span class="ent-label">Shoot Time</span><span
                                    class="ent-value">{{singleEpisodeData[0].shootTime || '--'}}</span></div>
                            <div class="ent-field"><span class="ent-label">Episode Due Date</span><span
                                    class="ent-value">{{ (singleEpisodeData[0].episodeDueDate &&
                                    singleEpisodeData[0].episodeDueDate !== 0 ? (singleEpisodeData[0].episodeDueDate |
                                    date:'mediumDate') : null) || '--'}}</span></div>
                        </div>
                        
                    </div>
                    
                    <!-- PCR / Cameraman Information -->
                    <div class="ent-card" *ngIf="(singleEpisodeData[0].outDoor && singleEpisodeData[0].cameraManUser) || (singleEpisodeData[0].outDoor === false && singleEpisodeData[0].pcrUser)">
                        <h5 class="ent-card-title">{{ singleEpisodeData[0].outDoor ? 'Cameraman Information' : 'PCR Information' }}</h5>
                        <div class="ent-card-grid-3">
                            <ng-container *ngIf="singleEpisodeData[0].outDoor">
                                <div class="ent-field"><span class="ent-label">Assign To Date</span><span class="ent-value">{{ (singleEpisodeData[0].assignToCameraManOnDate && singleEpisodeData[0].assignToCameraManOnDate !== 0 ? (singleEpisodeData[0].assignToCameraManOnDate | date:'mediumDate') : null) || '--'}}</span></div>
                                <div class="ent-field"><span class="ent-label">Cameraman User</span><span class="ent-value">{{singleEpisodeData[0].cameraManUser || '--'}}</span></div>
                                <div class="ent-field"><span class="ent-label">Start Date</span><span class="ent-value">{{ (singleEpisodeData[0].cameraManStartDate && singleEpisodeData[0].cameraManStartDate !== 0 ? (singleEpisodeData[0].cameraManStartDate | date:'mediumDate') : null) || '--'}}</span></div>
                                <div class="ent-field"><span class="ent-label">End Date</span><span class="ent-value">{{ (singleEpisodeData[0].cameraManEndDate && singleEpisodeData[0].cameraManEndDate !== 0 ? (singleEpisodeData[0].cameraManEndDate | date:'mediumDate') : null) || '--'}}</span></div>
                                <div class="ent-field"><span class="ent-label">No. of Days</span><span class="ent-value">{{singleEpisodeData[0].noOfDaysWithCameraman || '0'}}</span></div>
                                <div class="ent-field"><span class="ent-label">No. of Hours</span><span class="ent-value">{{singleEpisodeData[0].noOfHoursWithCameraman || '0'}}</span></div>
                                <div class="ent-field"><span class="ent-label">Assets Taken</span><span class="ent-value">{{singleEpisodeData[0].listOfAssetsTakenWithThem?.join ? singleEpisodeData[0].listOfAssetsTakenWithThem.join(', ') : (singleEpisodeData[0].listOfAssetsTakenWithThem || '--')}}</span></div>
                                <div class="ent-field"><span class="ent-label">Assets Received On</span><span class="ent-value">{{ (singleEpisodeData[0].assetsRecievedOn && singleEpisodeData[0].assetsRecievedOn !== 0 ? (singleEpisodeData[0].assetsRecievedOn | date:'mediumDate') : null) || '--'}}</span></div>
                                <div class="ent-field"><span class="ent-label">Assets Returned On</span><span class="ent-value">{{ (singleEpisodeData[0].assetsReturnedOn && singleEpisodeData[0].assetsReturnedOn !== 0 ? (singleEpisodeData[0].assetsReturnedOn | date:'mediumDate') : null) || '--'}}</span></div>
                            </ng-container>
                            
                            <ng-container *ngIf="!singleEpisodeData[0].outDoor">
                                <div class="ent-field"><span class="ent-label">Assign To Date</span><span class="ent-value">{{ (singleEpisodeData[0].assignToPcrOnDate && singleEpisodeData[0].assignToPcrOnDate !== 0 ? (singleEpisodeData[0].assignToPcrOnDate | date:'mediumDate') : null) || '--'}}</span></div>
                                <div class="ent-field"><span class="ent-label">PCR User</span><span class="ent-value">{{singleEpisodeData[0].pcrUser || '--'}}</span></div>
                                <div class="ent-field"><span class="ent-label">Start Date</span><span class="ent-value">{{ (singleEpisodeData[0].pcrStartDate && singleEpisodeData[0].pcrStartDate !== 0 ? (singleEpisodeData[0].pcrStartDate | date:'mediumDate') : null) || '--'}}</span></div>
                                <div class="ent-field"><span class="ent-label">End Date</span><span class="ent-value">{{ (singleEpisodeData[0].pcrEndDate && singleEpisodeData[0].pcrEndDate !== 0 ? (singleEpisodeData[0].pcrEndDate | date:'mediumDate') : null) || '--'}}</span></div>
                                <div class="ent-field"><span class="ent-label">No. of Days</span><span class="ent-value">{{singleEpisodeData[0].noOfDaysInPcr || '0'}}</span></div>
                                <div class="ent-field"><span class="ent-label">No. of Hours</span><span class="ent-value">{{singleEpisodeData[0].noOfHoursInPcr || '0'}}</span></div>
                            </ng-container>
                        </div>
                    </div>

                    <div class="ent-grid">
                        <!-- Editor Information -->
                        <div class="ent-card" *ngIf="singleEpisodeData[0].editorUser">
                            <h5 class="ent-card-title">Editor Information</h5>
                            <div class="ent-card-grid-2">
                                <div class="ent-field"><span class="ent-label">Editor</span><span
                                        class="ent-value">{{singleEpisodeData[0].editorUser || '--'}}</span></div>
                                <div class="ent-field"><span class="ent-label">Assigned Date</span><span
                                        class="ent-value">{{ (singleEpisodeData[0].assignToEditorOnDate &&
                                        singleEpisodeData[0].assignToEditorOnDate !== 0 ?
                                        (singleEpisodeData[0].assignToEditorOnDate |
                                        date:'medium') : null) || '--'}}</span></div>
                                <div class="ent-field"><span class="ent-label">Started Date</span><span
                                        class="ent-value">{{ (singleEpisodeData[0].editStartDate &&
                                        singleEpisodeData[0].editStartDate !== 0 ? (singleEpisodeData[0].editStartDate |
                                        date:'medium') : null) ||
                                        '--'}}</span></div>
                                <div class="ent-field"><span class="ent-label">Due Date</span><span class="ent-value">{{
                                        (singleEpisodeData[0].editDueDate &&
                                        singleEpisodeData[0].editDueDate !== 0 ? (singleEpisodeData[0].editDueDate |
                                        date:'mediumDate') : null) ||
                                        '--'}}</span></div>
                                <div class="ent-field"><span class="ent-label">Completed Date</span><span
                                        class="ent-value">{{ (singleEpisodeData[0].editEndDate &&
                                        singleEpisodeData[0].editEndDate !== 0 ? (singleEpisodeData[0].editEndDate |
                                        date:'medium') : null) ||
                                        '--'}}</span></div>
                            </div>
                        </div>



                        <!-- Graphics Team -->
                        <div class="ent-card" *ngIf="singleEpisodeData[0].graphicsUser">
                            <h5 class="ent-card-title">Graphics Team</h5>
                            <div class="ent-card-grid-2">
                                <div class="ent-field"><span class="ent-label">Graphics User</span><span
                                        class="ent-value">{{singleEpisodeData[0].graphicsUser || '--'}}</span></div>
                                <div class="ent-field"><span class="ent-label">Assigned Date</span><span
                                        class="ent-value">{{ (singleEpisodeData[0].assignToGraphicsTeamOnDate &&
                                        singleEpisodeData[0].assignToGraphicsTeamOnDate !== 0 ?
                                        (singleEpisodeData[0].assignToGraphicsTeamOnDate |
                                        date:'medium') : null) || '--'}}</span></div>
                                <div class="ent-field"><span class="ent-label">Started Date</span><span
                                        class="ent-value">{{ (singleEpisodeData[0].graphicsCreationStartDate &&
                                        singleEpisodeData[0].graphicsCreationStartDate !== 0 ?
                                        (singleEpisodeData[0].graphicsCreationStartDate |
                                        date:'medium') : null) ||
                                        '--'}}</span></div>
                                <div class="ent-field"><span class="ent-label">Due Date</span><span class="ent-value">{{
                                        (singleEpisodeData[0].graphicsDueDate &&
                                        singleEpisodeData[0].graphicsDueDate !== 0 ?
                                        (singleEpisodeData[0].graphicsDueDate |
                                        date:'mediumDate') : null) ||
                                        '--'}}</span></div>
                                <div class="ent-field"><span class="ent-label">Completed Date</span><span
                                        class="ent-value">{{ (singleEpisodeData[0].graphicsCreationEndDate &&
                                        singleEpisodeData[0].graphicsCreationEndDate !== 0 ?
                                        (singleEpisodeData[0].graphicsCreationEndDate |
                                        date:'medium') : null) ||
                                        '--'}}</span></div>
                            </div>
                        </div>

                        <!-- Title Team -->
                        <div class="ent-card" *ngIf="singleEpisodeData[0].titleCreationUser">
                            <h5 class="ent-card-title">Title Team</h5>
                            <div class="ent-card-grid-2">
                                <div class="ent-field"><span class="ent-label">Assigned User</span><span
                                        class="ent-value">{{singleEpisodeData[0].titleCreationUser || '--'}}</span>
                                </div>
                                <div class="ent-field"><span class="ent-label">Assigned Date</span><span
                                        class="ent-value">{{ (singleEpisodeData[0].assignToTitleTeamOnDate &&
                                        singleEpisodeData[0].assignToTitleTeamOnDate !== 0 ?
                                        (singleEpisodeData[0].assignToTitleTeamOnDate |
                                        date:'medium') : null) || '--'}}</span></div>
                                <div class="ent-field"><span class="ent-label">Started Date</span><span
                                        class="ent-value">{{ (singleEpisodeData[0].titleCreationStartDate &&
                                        singleEpisodeData[0].titleCreationStartDate !== 0 ?
                                        (singleEpisodeData[0].titleCreationStartDate |
                                        date:'medium') : null) ||
                                        '--'}}</span></div>
                                <div class="ent-field"><span class="ent-label">Due Date</span><span class="ent-value">{{
                                        (singleEpisodeData[0].titleDueDate &&
                                        singleEpisodeData[0].titleDueDate !== 0 ? (singleEpisodeData[0].titleDueDate |
                                        date:'mediumDate') : null) ||
                                        '--'}}</span></div>
                                <div class="ent-field"><span class="ent-label">Completed Date</span><span
                                        class="ent-value">{{ (singleEpisodeData[0].titleCreationEndDate &&
                                        singleEpisodeData[0].titleCreationEndDate !== 0 ?
                                        (singleEpisodeData[0].titleCreationEndDate |
                                        date:'medium') : null) ||
                                        '--'}}</span></div>
                                <div class="ent-field"><span class="ent-label">Approved Title</span><span
                                        class="ent-value">{{singleEpisodeData[0].approvedTitle
                                        || '--'}}</span></div>
                                <div class="ent-field" style="grid-column: span 2;"
                                    *ngIf="singleEpisodeData[0].suggestedTitles?.length">
                                    <span class="ent-label">Suggested Titles</span>
                                    <div class="ent-pills">
                                        <span class="ent-pill"
                                            *ngFor="let title of singleEpisodeData[0].suggestedTitles">{{title.titleName}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Quality Check Team -->
                        <div class="ent-card" *ngIf="singleEpisodeData[0].qualityCheckUser">
                            <h5 class="ent-card-title">Quality Check Team</h5>
                            <div class="ent-card-grid-2">
                                <div class="ent-field"><span class="ent-label">Quality Check User</span><span
                                        class="ent-value">{{singleEpisodeData[0].qualityCheckUser || '--'}}</span></div>
                                <div class="ent-field"><span class="ent-label">Assigned Date</span><span
                                        class="ent-value">{{ (singleEpisodeData[0].assignToQualityCheckTeamOnDate &&
                                        singleEpisodeData[0].assignToQualityCheckTeamOnDate !== 0 ?
                                        (singleEpisodeData[0].assignToQualityCheckTeamOnDate |
                                        date:'medium') : null) || '--'}}</span></div>
                                <div class="ent-field"><span class="ent-label">Started Date</span><span
                                        class="ent-value">{{ (singleEpisodeData[0].qualityCheckStartDate &&
                                        singleEpisodeData[0].qualityCheckStartDate !== 0 ?
                                        (singleEpisodeData[0].qualityCheckStartDate |
                                        date:'medium') : null) ||
                                        '--'}}</span></div>
                                <div class="ent-field"><span class="ent-label">Due Date</span><span class="ent-value">{{
                                        (singleEpisodeData[0].qualityDueDate &&
                                        singleEpisodeData[0].qualityDueDate !== 0 ? (singleEpisodeData[0].qualityDueDate
                                        |
                                        date:'mediumDate') : null) ||
                                        '--'}}</span></div>
                            </div>
                        </div>

                        <!-- SEO Team -->
                        <div class="ent-card" *ngIf="singleEpisodeData[0].seoUser">
                            <h5 class="ent-card-title">SEO Team</h5>
                            <div class="ent-card-grid-2">
                                <div class="ent-field"><span class="ent-label">SEO User</span><span
                                        class="ent-value">{{singleEpisodeData[0].seoUser || '--'}}</span></div>
                                <div class="ent-field"><span class="ent-label">Assigned Date</span><span
                                        class="ent-value">{{ (singleEpisodeData[0].assignToSEOTeamOnDate &&
                                        singleEpisodeData[0].assignToSEOTeamOnDate !== 0 ?
                                        (singleEpisodeData[0].assignToSEOTeamOnDate |
                                        date:'medium') : null) || '--'}}</span></div>
                                <div class="ent-field"><span class="ent-label">Started Date</span><span
                                        class="ent-value">{{ (singleEpisodeData[0].seoTeamStartDate &&
                                        singleEpisodeData[0].seoTeamStartDate !== 0 ?
                                        (singleEpisodeData[0].seoTeamStartDate |
                                        date:'medium') : null) ||
                                        '--'}}</span></div>
                                <div class="ent-field"><span class="ent-label">Due Date</span><span class="ent-value">{{
                                        (singleEpisodeData[0].seoDueDate &&
                                        singleEpisodeData[0].seoDueDate !== 0 ? (singleEpisodeData[0].seoDueDate |
                                        date:'mediumDate') : null) ||
                                        '--'}}</span></div>
                                <div class="ent-field"><span class="ent-label">Completed Date</span><span
                                        class="ent-value">{{ (singleEpisodeData[0].seoTeamEndDate &&
                                        singleEpisodeData[0].seoTeamEndDate !== 0 ? (singleEpisodeData[0].seoTeamEndDate
                                        |
                                        date:'medium') : null) ||
                                        '--'}}</span></div>
                                <div class="ent-field"><span class="ent-label">Approved SEO Title</span><span
                                        class="ent-value">{{singleEpisodeData[0].approvedSeoTitle || '--'}}</span>
                                </div>
                                <div class="ent-field" style="grid-column: span 2;"
                                    *ngIf="singleEpisodeData[0].suggestedSEOTitles?.length">
                                    <span class="ent-label">Suggested SEO Titles</span>
                                    <div class="ent-pills">
                                        <span class="ent-pill"
                                            *ngFor="let title of singleEpisodeData[0].suggestedSEOTitles">{{title.seoTitleName}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Publishing Team -->
                        <div class="ent-card"
                            *ngIf="singleEpisodeData[0].publishingUser || singleEpisodeData[0].episodeYouTubeURL">
                            <h5 class="ent-card-title">Publishing Team</h5>
                            <div class="ent-card-grid-2">
                                <div class="ent-field"><span class="ent-label">Publishing User</span><span
                                        class="ent-value">{{singleEpisodeData[0].publishingUser || '--'}}</span></div>
                                <div class="ent-field"><span class="ent-label">Assigned Date</span><span
                                        class="ent-value">{{ (singleEpisodeData[0].assignToPublishingTeamOnDate &&
                                        singleEpisodeData[0].assignToPublishingTeamOnDate !== 0 ?
                                        (singleEpisodeData[0].assignToPublishingTeamOnDate |
                                        date:'medium') : null) || '--'}}</span></div>
                                <div class="ent-field"><span class="ent-label">Started Date</span><span
                                        class="ent-value">{{ (singleEpisodeData[0].publishingStartDate &&
                                        singleEpisodeData[0].publishingStartDate !== 0 ?
                                        (singleEpisodeData[0].publishingStartDate |
                                        date:'medium') : null) ||
                                        '--'}}</span></div>
                                <div class="ent-field"><span class="ent-label">Due Date</span><span class="ent-value">{{
                                        (singleEpisodeData[0].publishingDueDate &&
                                        singleEpisodeData[0].publishingDueDate !== 0 ?
                                        (singleEpisodeData[0].publishingDueDate |
                                        date:'mediumDate') : null) ||
                                        '--'}}</span></div>
                                <div class="ent-field"><span class="ent-label">Completed Date</span><span
                                        class="ent-value">{{ (singleEpisodeData[0].publishingEndDate &&
                                        singleEpisodeData[0].publishingEndDate !== 0 ?
                                        (singleEpisodeData[0].publishingEndDate |
                                        date:'medium') : null) ||
                                        '--'}}</span></div>
                                <div class="ent-field" style="grid-column: span 2;"
                                    *ngIf="singleEpisodeData[0].episodeYouTubeURL">
                                    <span class="ent-label">YouTube URL</span>
                                    <span class="ent-value"><a [href]="singleEpisodeData[0].episodeYouTubeURL"
                                            target="_blank">{{singleEpisodeData[0].episodeYouTubeURL}}</a></span>
                                </div>
                            </div>
                        </div>

                        <!-- Common Notes Section -->
                        <div class="ent-card" style="grid-column: 1 / -1;"
                            *ngIf="singleEpisodeData[0].commonNotes?.length">
                            <h5 class="ent-card-title">Chat</h5>
                            <div class="ent-notes-list" style="max-height: 350px; overflow-y: auto;">
                                <div class="ent-note-card" *ngFor="let note of singleEpisodeData[0].commonNotes"
                                    [ngClass]="isMyNote(note) ? 'chat-bubble-mine' : 'chat-bubble-other'">
                                    <p class="ent-note-body">{{note.episodeNotes || note.commonNotes || note.editorNotes
                                        || note.titleNotes || note.graphicsNotes || note.seoNotes ||
                                        note.qualityCheckNotes || note.publishingNotes}}</p>
                                    <div class="ent-note-footer">
                                        <div class="ent-note-user"><i class="bi bi-person-fill"></i> {{note.userName ||
                                            note.userId || 'User'}}</div>
                                        <div class="ent-note-time">
                                            <span *ngIf="note.date">{{note.date | date:'short'}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <!-- Footer -->
            </div>
            <div class="modal-footer ent-modal-footer" *ngIf="singleEpisodeData[0]">
                <div class="ent-footer-left">
                    <!-- Assignments -->
                    <ng-container *ngIf="singleEpisodeData[0].currentStage === 'EPISODE_CREATION' || !singleEpisodeData[0].currentStage">
                        <!-- If outDoor is true -> Assign to Cameraman -->
                        <div class="ent-assignment-section" *ngIf="singleEpisodeData[0].outDoor">
                            <select class="ent-select" [(ngModel)]="selectedUserIdToAssign">
                                <option value="">Select Cameraman</option>
                                <option *ngFor="let user of userList" [value]="user.userName">{{user.userName}}</option>
                            </select>
                            <ng-multiselect-dropdown 
                                [placeholder]="'Select Assets'" 
                                [settings]="dropdownSettings" 
                                [data]="cameraAssetsList" 
                                [(ngModel)]="selectedAssetsToAssign">
                            </ng-multiselect-dropdown>
                            <button class="ent-btn-primary" (click)="assignToCameraman()">Assign to Cameraman</button>
                        </div>

                        <!-- If outDoor is false -> Assign to PCR -->
                        <div class="ent-assignment-section" *ngIf="!singleEpisodeData[0].outDoor">
                            <select class="ent-select" [(ngModel)]="selectedUserIdToAssign">
                                <option value="">Select PCR User</option>
                                <option *ngFor="let user of userList" [value]="user.userName">{{user.userName}}</option>
                            </select>
                            <button class="ent-btn-primary" (click)="assignToPcr()">Assign to PCR</button>
                        </div>
                    </ng-container>

                    <div class="ent-assignment-section"
                        *ngIf="singleEpisodeData[0].currentStage === 'EDITOR' && singleEpisodeData[0].episodeStatus === 'EDIT_COMPLETED'">
                        <select class="ent-select" [(ngModel)]="selectedUserIdToAssign">
                            <option value="">Select Graphics User</option>
                            <option *ngFor="let user of graphicsUserList" [value]="user.userName">{{user.userName}}
                            </option>
                        </select>
                        <button class="ent-btn-primary" (click)="assignToGraphics()">Assign to Graphics</button>
                    </div>

                    <div class="ent-assignment-section"
                        *ngIf="singleEpisodeData[0].currentStage === 'GRAPHICS' && singleEpisodeData[0].episodeStatus === 'GRAPHICS_COMPLETED'">
                        <select class="ent-select" [(ngModel)]="selectedUserIdToAssign">
                            <option value="">Select Title User</option>
                            <option *ngFor="let user of titleUserList" [value]="user.userName">{{user.userName}}
                            </option>
                        </select>
                        <button class="ent-btn-primary" (click)="assignToTitle()">Assign to Title</button>
                    </div>

                    <div class="ent-assignment-section"
                        *ngIf="singleEpisodeData[0].currentStage === 'TITLE' && singleEpisodeData[0].episodeStatus === 'TITLE_COMPLETED'">
                        <select class="ent-select" [(ngModel)]="selectedUserIdToAssign">
                            <option value="">Select Quality Check User</option>
                            <option *ngFor="let user of qualityCheckUserList" [value]="user.userName">{{user.userName}}
                            </option>
                        </select>
                        <button class="ent-btn-primary" (click)="assignToQualityCheck()">Assign to Quality
                            Check</button>
                    </div>

                    <div class="ent-assignment-section"
                        *ngIf="singleEpisodeData[0].currentStage === 'QUALITY_CHECK' && singleEpisodeData[0].episodeStatus === 'QUALITY_CHECK_COMPLETED'">
                        <select class="ent-select" [(ngModel)]="selectedUserIdToAssign">
                            <option value="">Select SEO User</option>
                            <option *ngFor="let user of seoUserList" [value]="user.userName">{{user.userName}}</option>
                        </select>
                        <button class="ent-btn-primary" (click)="assignToSEO()">Assign to SEO</button>
                    </div>

                    <div class="ent-assignment-section"
                        *ngIf="singleEpisodeData[0].currentStage === 'SEO' && singleEpisodeData[0].episodeStatus === 'SEO_COMPLETED'">
                        <select class="ent-select" [(ngModel)]="selectedUserIdToAssign">
                            <option value="">Select Publishing User</option>
                            <option *ngFor="let user of publishingUserList" [value]="user.userName">{{user.userName}}
                            </option>
                        </select>
                        <button class="ent-btn-primary" (click)="assignToPublishing()">Assign to Publishing</button>
                    </div>
                </div>
                <div class="ent-footer-right">
                    <button class="ent-btn-secondary" data-dismiss="modal" (click)="closePopUp()">Close</button>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Delete Modal -->
<div class="modal fade" id="deleteModal" tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="deleteModalLabel">Confirmation
                    <span data-dismiss="modal">
                        <i class="bi bi-x-lg" (click)="clearData()" id="closeModalButton3"></i>
                    </span>
                </h5>
            </div>
            <div class="modal-body">
                <p>Are you sure you want to delete <span class="delete-span">“{{recordName}}”</span>?</p>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" (click)="clearData()"
                        data-dismiss="modal">Cancel</button>
                    <button type="button" (click)="deleteEpisode()" class="btn btn-primary"
                        data-dismiss="modal">Delete</button>
                </div>
            </div>
        </div>
    </div>
</div>